export default {
    undefined: 'Unknown error',
    0: 'Success',
    1000: 'DatabaseError',
    1001: 'ParsedError',
    1002: 'ParameterIsNull',
    2000: 'UserNotFound',
    2001: 'UserAlreadyExist',
    2002: 'UserDeviceAlreadyExist',
    2003: 'PhoneNumberIsObjectOwner',
    2004: 'UserEmailNotFound',
    2005: 'UserNoRightsToControlTheDevice',
    2006: 'SendEmailMessageError',
    2007: 'UserPasswordError',
    2100: 'UserPhoneAuthWait',
    2200: 'ErrorSendSms',
    2300: 'RefreshTokenNotFound',
    3000: 'DeviceNotFound',
    3001: 'DevicesNotFound',
    3011: 'EventNotFound'
}